export type UnitsNullKpiKey =
  | 'name'
  | 'legalName'
  | 'status'
  | 'edc'
  | 'productType'
  | 'energyType'
  | 'submarket'
  | 'state'
  | 'unitType'
  | 'tariffSubgroup'
  | 'tariffModality'
  | 'energyContractingModel'
  | 'volumeMwm'
  | 'exposure'
  | 'exposurePercentage'
  | 'managementCost'
  | 'demandPeakBlue'
  | 'demandOffPeak'
  | 'demandPeakBeforeBlue'
  | 'demandOffPeakBefore'
  | 'demandPeakBeforeLawBlue'
  | 'demandOffPeakBeforeLaw'
  | 'generatorCost'
  | 'migrationDate'
  | 'expectedMigrationDate'
  | 'aclBefore2025Law'
  | 'city'
  | 'address'
  | 'postalCode'
  | 'docType'
  | 'docNumber'
  | 'installationCode'
  | 'newInstallationCode'
  | 'edcCustomerCode'
  | 'assetCode'
  | 'crmId'
  | 'cceeProfile'
  | 'isNewConnection'
  | 'powerGenerator';

export interface UnitsNullKpiItem {
  key: UnitsNullKpiKey;
  label: string;
  hint?: string;
  required?: boolean;
}

export const UNITS_NULL_KPI_ITEMS: UnitsNullKpiItem[] = [
  { key: 'name', label: 'Nome da unidade', required: true },
  { key: 'legalName', label: 'Razão social', required: true },
  { key: 'status', label: 'Status', required: true },
  { key: 'edc', label: 'Distribuidora', required: true },
  { key: 'productType', label: 'Tipo de produto', required: true },
  { key: 'energyType', label: 'Tipo de energia', required: true },
  { key: 'submarket', label: 'Submercado', required: true },
  { key: 'state', label: 'Estado', required: true },
  { key: 'unitType', label: 'Tipo de UC', required: true },
  { key: 'tariffSubgroup', label: 'Subgrupo', required: true },
  { key: 'tariffModality', label: 'Modalidade', required: true },
  { key: 'energyContractingModel', label: 'Modelo contratação', required: true },
  { key: 'volumeMwm', label: 'Volume (MWm)', required: true },
  { key: 'exposure', label: 'Exposição', required: true },
  { key: 'exposurePercentage', label: '% Exposição', required: true },
  { key: 'managementCost', label: 'Custo gestão', required: true },
  { key: 'demandPeakBlue', label: 'Demanda Ponta', hint: 'Apenas clientes Azuis', required: true },
  { key: 'demandOffPeak', label: 'Demanda FP', required: true },
  {
    key: 'demandPeakBeforeBlue',
    label: 'Demanda pré migração Ponta',
    hint: 'Apenas clientes Azuis',
    required: true,
  },
  { key: 'demandOffPeakBefore', label: 'Demanda pré migração FP', required: true },
  {
    key: 'demandPeakBeforeLawBlue',
    label: 'Demanda com desconto Ponta',
    hint: 'Apenas clientes Azuis',
    required: true,
  },
  { key: 'demandOffPeakBeforeLaw', label: 'Demanda com desconto FP', required: true },
  { key: 'generatorCost', label: 'Custo gerador', required: true },
  { key: 'migrationDate', label: 'Data migração', required: true },
  { key: 'expectedMigrationDate', label: 'Expect. migração', required: true },
  { key: 'aclBefore2025Law', label: 'ACL antes da Lei', required: true },
  { key: 'city', label: 'Cidade', required: true },
  { key: 'address', label: 'Endereço', required: true },
  { key: 'postalCode', label: 'CEP', required: true },
  { key: 'docType', label: 'Tipo doc', required: true },
  { key: 'docNumber', label: 'Número do DOC', required: true },
  { key: 'installationCode', label: 'Cód. de Instalação', required: true },
  { key: 'newInstallationCode', label: 'Novo cód. instalação', required: true },
  { key: 'edcCustomerCode', label: 'Cód. cliente (EDC)', required: true },
  { key: 'assetCode', label: 'Cód. ativo', required: true },
  { key: 'cceeProfile', label: 'Profile CCEE', required: true },
  { key: 'isNewConnection', label: 'Nova conexão', required: true },
  { key: 'powerGenerator', label: 'Gerador', required: true },
];

export const EMPTY_NULL_KPIS: Record<UnitsNullKpiKey, number> = {
  name: 0,
  legalName: 0,
  status: 0,
  edc: 0,
  productType: 0,
  energyType: 0,
  submarket: 0,
  state: 0,
  unitType: 0,
  tariffSubgroup: 0,
  tariffModality: 0,
  energyContractingModel: 0,
  volumeMwm: 0,
  exposure: 0,
  exposurePercentage: 0,
  managementCost: 0,
  demandPeakBlue: 0,
  demandOffPeak: 0,
  demandPeakBeforeBlue: 0,
  demandOffPeakBefore: 0,
  demandPeakBeforeLawBlue: 0,
  demandOffPeakBeforeLaw: 0,
  generatorCost: 0,
  migrationDate: 0,
  expectedMigrationDate: 0,
  aclBefore2025Law: 0,
  city: 0,
  address: 0,
  postalCode: 0,
  docType: 0,
  docNumber: 0,
  installationCode: 0,
  newInstallationCode: 0,
  edcCustomerCode: 0,
  assetCode: 0,
  crmId: 0,
  cceeProfile: 0,
  isNewConnection: 0,
  powerGenerator: 0,
};
